export default {"src":"/planos/_next/static/media/proposal-error.41ff8119.svg","height":150,"width":168,"blurWidth":0,"blurHeight":0};